// extracted by mini-css-extract-plugin
export var animComponent = "styles-module--animComponent--2oDKE";
export var starsSvgWrap = "styles-module--starsSvgWrap--1ZUCd";
export var bounce = "styles-module--bounce--30KsO";
export var bounceReverce = "styles-module--bounceReverce--5bHvr";
export var jsAnimInit = "styles-module--jsAnimInit--22229";